// Libs
import React, { useCallback } from 'react';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';

// Components
import { Button, Typography, Box } from '@mui/material';
import { ReactComponent as PhoneIcon } from '../../../assets/svg/phone.svg';
import { ReactComponent as FileIcon } from '../../../assets/svg/file.svg';
import { ReactComponent as LetterIcon } from '../../../assets/svg/mail.svg';

// Hooks
import useUI from '../../../hooks/useUI';
import useUser from '../../../hooks/useUser';

import { useStyles } from './SupportCardStyles';

const SupportCard = (props) => {
  const { header, text, phoneNumber, buttonInfo, videoButtonInfo } = props;
  const {
    type: buttonType,
    content: buttonContent,
    title: buttonTitle,
  } = buttonInfo || {};
  const { isKiteUser } = useUser();
  const { classes, cx } = useStyles({ isKiteUser });
  const { isMobileMode, isDesktopMode } = useUI();

  const onButtonClick = useCallback(() => {
    if (buttonType === 'email') {
      window.location.href = `mailto:${buttonContent}`;
    } else {
      window.open(buttonContent, '_blank', 'noopener,noreferrer');
    }
  }, [buttonContent, buttonType]);

  const onVideoButtonClick = () => {
    window.open(videoButtonInfo.content, '_blank', 'noopener,noreferrer');
  };

  const resolveButtonIcon = () => {
    return buttonType === 'email' ? (
      <LetterIcon className={classes.cardIcon} />
    ) : (
      <FileIcon className={classes.cardIcon} />
    );
  };

  return (
    <div data-testid="support-card" className={classes.supportCard}>
      <Typography variant="textMdSemibold">{header}</Typography>
      <Typography
        variant={isMobileMode ? 'textMd' : 'textSm'}
        color={'#54565B'}>
        {text}
      </Typography>

      {phoneNumber && (
        <Button
          className={cx(classes.phoneButton, classes.flatButton)}
          startIcon={<PhoneIcon className={classes.cardIcon} />}
          onClick={() => {
            window.location.href = `tel:${phoneNumber}`;
          }}>
          {phoneNumber}
        </Button>
      )}

      <Box
        flexGrow={1}
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'end'}
        width={isDesktopMode ? 'unset' : '100%'}>
        {videoButtonInfo && (
          <Button
            variant="contained"
            className={cx(classes.mediaButton, classes.videoButton)}
            onClick={onVideoButtonClick}
            startIcon={<PlayCircleIcon />}>
            {videoButtonInfo.title}
          </Button>
        )}

        <Button
          variant="contained"
          className={classes.mediaButton}
          onClick={onButtonClick}
          startIcon={resolveButtonIcon()}>
          {buttonTitle}
        </Button>
      </Box>
    </div>
  );
};

export default SupportCard;
